import { Checkbox, FormControl, FormHelperText, InputLabel, MenuItem } from '@material-ui/core';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { SelectProps } from '@material-ui/core/Select';
import { Field } from 'formik';
import { Select } from 'formik-material-ui';
import React from 'react';
import ReactDOM from 'react-dom';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
    anchorOrigin: {
        horizontal: 'left',
        vertical: 'bottom',
    },
    getContentAnchorEl: null,
};

export interface ISelectFieldProps<T> extends SelectProps {
    name: string;
    label: string;
    items?: T[];
    inputId: string;
    required?: boolean;
    fullWidth?: boolean;
    errorMessage?: string | Array<string | undefined>;
    checkedItems?: string[];
    cypressLabel?: string;
    childCypressLabel?: string;
    getName: (item: T) => string;
    getValue: (item: T) => string;
    outlined?: boolean;
    shrinkLabel?: boolean;
}

export default class SelectField<T> extends React.Component<ISelectFieldProps<T>> {
    private InputLabelRef: InputLabel | null;
    constructor(props: ISelectFieldProps<T>) {
        super(props);
    }

    public componentDidMount() {
        if (this.props.outlined) {
            this.setState({
                labelWidth: (ReactDOM.findDOMNode(this.InputLabelRef) as HTMLElement).offsetWidth,
            });
        }
    }

    public state = {
        labelWidth: 0,
    };

    public render() {
        const {
            name,
            label,
            items,
            inputId,
            fullWidth = false,
            required = false,
            multiple = false,
            checkedItems = Array<string>(),
            errorMessage,
            getName,
            getValue,
            outlined,
            cypressLabel,
            childCypressLabel,
            shrinkLabel,
        } = this.props;

        return (
            <FormControl
                fullWidth={fullWidth}
                required={required}
                error={errorMessage !== undefined}
                variant={outlined ? 'outlined' : 'standard'}
            >
                <InputLabel
                    variant={outlined ? 'outlined' : 'standard'}
                    htmlFor={inputId}
                    shrink={shrinkLabel}
                    ref={
                        outlined
                            ? (ref) => {
                                  this.InputLabelRef = ref;
                              }
                            : undefined
                    }
                >
                    {label}
                </InputLabel>
                <Field
                    data-cy={cypressLabel}
                    input={
                        outlined ? (
                            <OutlinedInput
                                id={inputId}
                                name={name}
                                labelWidth={this.state.labelWidth}
                                notched={shrinkLabel}
                            />
                        ) : (
                            undefined
                        )
                    }
                    component={Select}
                    name={name}
                    inputProps={{ id: inputId }}
                    MenuProps={MenuProps}
                    multiple={multiple}
                    renderValue={multiple ? this.renderText(items || []) : undefined}
                >
                    {items &&
                        items.map((item: T, index: number) => (
                            <MenuItem
                                data-cy={childCypressLabel}
                                key={index}
                                value={getValue(item)}
                            >
                                {multiple && (
                                    <Checkbox
                                        checked={(checkedItems as any).includes(getValue(item))}
                                    />
                                )}
                                {getName(item)}
                            </MenuItem>
                        ))}
                </Field>
                {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
            </FormControl>
        );
    }

    private renderText = (items: T[]) => (x: string[]) =>
        items
            .filter((i) => x.includes(this.props.getValue(i)))
            .map((i) => this.props.getName(i))
            .join(', ');
}



// WEBPACK FOOTER //
// ./src/common/SelectField/SelectField.tsx